import z from 'zod';

export const ApiVolcanoZod = z.object({
  name: z.string().min(1).max(100),
  number: z.string().max(10),
  latitude: z.coerce.number().min(-90).max(90).optional(),
  longitude: z.coerce.number().min(-180).max(360).optional(),
  area: z.string().max(100).optional(),
  summitElevationMetres: z.coerce.number().min(-6000).max(10000).optional(),
});
export type ApiVolcano = z.infer<typeof ApiVolcanoZod>;

export const ApiVolcanoIdZod = ApiVolcanoZod.pick({ number: true, name: true });
export type ApiVolcanoId = z.infer<typeof ApiVolcanoIdZod>;
